<template>
  <div class="checkout-page">
  <div class="checkout-content">
    <!-- <div class="contact-info">
      <h2>{{ t('checkout.contact_info') }}</h2>
      <input type="email" :placeholder="t('checkout.email_placeholder')">
    </div> -->

      <div class="shipping-address">
        <h2>{{ t('checkout.shipping_address') }}</h2>
        <div class="address-details" v-if="defaultAddress">
          <div class="address-info">
            <p><strong>{{ defaultAddress.firstName }} {{ defaultAddress.lastName }}</strong> {{ defaultAddress.phoneNumber }}</p>
            <p>{{ defaultAddress.address }}, {{ t('regions["'+defaultAddress.region+ '"]') }}, {{ t('countries["'+defaultAddress.country+ '"]') }}</p>
          </div>
          <span class="edit-button" @click="editAddress">{{ t('checkout.edit') }}</span>
        </div>
    <div v-else>
      <select v-model="addressForm.country" @change="updateRegions">
        <option>{{ t('checkout.select_country') }}</option>
        <option v-for="country in countries" :key="country.countrySlug" :value="country.countryName">{{ t('countries["'+country.countryName+ '"]') }}</option>
      </select>
      <div class="name-row">
        <input type="text" v-model="addressForm.firstName" :placeholder="t('checkout.first_name')">
        <input type="text" v-model="addressForm.lastName" :placeholder="t('checkout.last_name')">
      </div>
      <input type="text" v-model="addressForm.address" :placeholder="t('checkout.address')">
      <input type="text" v-model="addressForm.apartment" :placeholder="t('checkout.apartment')" v-if="showExtraAddress">
      <span v-if="!showExtraAddress" @click="toggleExtraAddress" class="add-extra-address">
        {{ t('checkout.add_apartment') }}
      </span>
      <div class="street-row">
        <input type="text" v-model="addressForm.region" :placeholder="t('checkout.city')">
        <select v-model="addressForm.city">
          <option v-for="region in regions" :key="region.shortCode" :value="region.name">{{ t('regions["'+region.name+ '"]') }}</option>
        </select>
      </div>
      <div class="postal-phone-row">
        <input type="text" v-model="addressForm.postalCode" :placeholder="t('checkout.postal_code')">
          <input type="text" v-model="addressForm.phone" :placeholder="t('checkout.phone')">
      </div>
    </div>
  </div>

    <div class="delivery-options">
      <h2>{{ t('checkout.delivery_options') }}</h2>
      <div class="delivery-option">
        <label>
          <input type="radio" name="delivery" value="到付" checked>
          {{ t('checkout.only_support_cash_on_delivery') }}
        </label>
        <span>{{ t('checkout.cash_on_delivery') }}</span>
      </div>
    </div>

    <button @click="initiatePayment" class="order-button">{{ t('checkout.place_order') }}</button>
  </div>

  <div class="order-summary">
    <h2>{{ t('checkout.order_summary') }}</h2>
    <div v-for="(item, index) in cartItems" :key="item.product_id" class="order-item">
      <span class="order-index">{{ index + 1 }}</span>
      <img :src="item.image" alt="Product Image" class="product-image">
      <div class="order-details">
        <p>{{ item.name }}</p>
        <p><s>{{ item.originalPrice }} USDT</s> {{ item.discountedPrice }} USDT</p>
        <!-- <p>{{ item.description }}</p> -->
      </div>
      <p class="order-price"><b>{{ item.discountedPrice }} USDT</b> <sup> X {{ item.quantity }}</sup></p>
    </div>
    <hr>
    <div class="summary-line">
      <span>{{ t('checkout.subtotal') }}</span>
      <span><b>{{ subtotal }} USDT</b></span>
    </div>
    <div class="summary-line">
      <span>{{ t('checkout.delivery') }}</span>
      <span>{{ t('checkout.cash_on_delivery') }}</span>
    </div>
    <div class="summary-line">
      <span>{{ t('checkout.delivery_to') }}</span>
      <span v-if="addressForm.region">{{ t('regions["'+addressForm.region+ '"]') }},{{ addressForm.city }}, {{ t('countries["'+addressForm.country+ '"]') }}</span>
    </div>
    <hr>
    <div class="summary-line total-line">
      <span>{{ t('checkout.total') }}</span>
      <span>{{ total }} USDT</span>
    </div>
  </div>
</div>
</template>

<script setup>
import { ref, onMounted,getCurrentInstance, watch, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import { allCountries } from 'country-region-data/dist/data.js';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
const store = useStore();
const router = useRouter();
const { t } = useI18n();
const { proxy } = getCurrentInstance(); 
const props = defineProps({
  walletConnect: {
    type: Object,
    required: true,
  },
});
const cartItems = ref([]);
const subtotal = ref(0);
const total = ref(0);
const regions = ref([]);
const showExtraAddress = ref(false);
let wc = null;
const defaultAddress = ref({
  region: '',
  country: '',
});
const addressForm = ref({
  firstName: '',
  lastName: '',
  address: '',
  apartment: '',
  city: '',
  region: '',
  country: '',
  phone: '',
  postalCode: '',
  countrySlug: '',
  regionSlug: '',
});

const countries = allCountries.map(([countryName, countrySlug, regions]) => ({
  countryName,
  countrySlug,
  regions: regions.map(([regionName, regionSlug]) => ({
    name: regionName,
    slug: regionSlug
  }))
}));

watch(()=> addressForm.value.country, (newCountry) => {
  const country = countries.find(country => country.countryName === newCountry);
  if(country){
    addressForm.value.countrySlug = country.countrySlug;
  } else {
    addressForm.value.countrySlug = '';
  }
});
watch(()=> addressForm.value.region, (newRegion) => {
  const region = regions.value.find(region => region.name === newRegion);
  if(region){
    addressForm.value.regionSlug = region.slug;
  } else {
    addressForm.value.regionSlug = '';
  }
});
const updateRegions = () => {
  const selectedCountry = countries.find(country => country.countryName === addressForm.value.country);
  regions.value = selectedCountry ? selectedCountry.regions : [];
};
const fetchCartItems = () => {
  const cart = localStorage.getItem('cart');
  if (cart) {
    cartItems.value = JSON.parse(cart);
    for(let item of cartItems.value){
      let product = localStorage.getItem('product_'+item.product_id);
      if(product){
        product = JSON.parse(product);
        item.discountedPrice = product.salePrice;
        item.originalPrice = product.regularPrice;
        item = Object.assign(item, product);
      }
    }
    calculateTotals();
  }
};

const calculateTotals = () => {
  subtotal.value = cartItems.value.reduce((sum, item) => sum + item.discountedPrice * item.quantity, 0);
  total.value = subtotal.value;
};

const initiatePayment = async () => {
  let txHashs = [];
  
  const productId = cartItems.value.map(item => item.product_id);
  const quantity = cartItems.value.map(item => item.quantity);
  await wc.buyPhone(productId, quantity, store.state.userProfile.referrerAddress, async (error, event) => { 
    console.log(event, "event");
    console.log(error, "error");
    if (error) {
        console.error('监听 BuyPhone 事件时出错:', error);
        proxy.$toast.error(error.message);
    } else {
        console.log('BuyPhone 事件:', event);
        console.log(event.returnValues, "event.returnValues");
        // 通知 Vuex 更新状态
        let response = await store.dispatch('handlePurchaseSuccess', { order: cartItems.value, event: event.returnValues, address: addressForm.value, invite_address: event.invite_addresse });
        console.log(response, 'response');
        if(response.success){       
          txHashs.push(event.returnValues.transactionHash);
          console.log(txHashs, "txHashs");
          localStorage.removeItem('cart');
          cartItems.value.map(d=> {
            localStorage.removeItem('product_'+d.product_id);
          });
          proxy.$toast.success(proxy.$t('walletConnect.purchaseSuccess'));
          router.push('/dashboard/order');
        } else {
          proxy.$toast.error(response.message);
        }
    }
  });
};

const toggleExtraAddress = () => {
  showExtraAddress.value = !showExtraAddress.value;
};

const loadDefaultAddress = () => {
  const address = localStorage.getItem('defaultAddress');
  if (address) {
    defaultAddress.value = JSON.parse(address);
    const fullName = defaultAddress.value.fullName.split(' ');
    defaultAddress.value.firstName = fullName[0];
    defaultAddress.value.lastName = fullName[1];
    defaultAddress.value.address = defaultAddress.value.street;
    defaultAddress.value.city = defaultAddress.value.region;
    defaultAddress.value.phone = defaultAddress.value.phoneNumber;
    addressForm.value = { ...defaultAddress.value };
  }
};

const editAddress = () => {
  if (defaultAddress.value) {
    addressForm.value = { ...defaultAddress.value };
    defaultAddress.value = null;
    updateRegions();
  }
};

onMounted(() => {
  wc = props.walletConnect;
  fetchCartItems();
  loadDefaultAddress();
});
</script>

<style scoped>
.checkout-page {
  display: flex;
  flex-direction: column-reverse;
  padding: 20px;
  gap: 20px;
}

.checkout-content, .order-summary {
  width: 100%;
}

.order-summary {
  border: none;
  position: static;
  padding: 20px 0;
}

@media (min-width: 768px) {
  .order-summary {
    margin: 0 20px;
  }
}

.order-summary .order-item:first-child {
  border-top: 1px solid #e5e5e5;
}

.order-summary .order-item:not(:last-child) {
  border-bottom: 1px solid #e5e5e5;
}
.order-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 20px;
}

.order-index {
  margin-right: 10px;
  border: 1px solid #030303;
  font-weight: bold;
  color: #0f0f0f;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  margin-right: 10px;
}

@media (max-width: 767px) {
  .product-image {
    width: 25px;
    height: 25px;
  }
}

.order-items .order-details {
  flex: 1;
}

.order-price {
  font-weight: 700;
}

.summary-line {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  padding: 0 20px;
}

.total-line {
  font-weight: bold;
  font-size: 18px;
  margin-top: 10px;
}

.order-summary h2 {
  padding-left: 20px;
}

hr {
  border: none;
  border-top: 1px solid #eee;
  margin: 10px 0;
}

.add-extra-address {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  margin-top: 10px;
}

.add-extra-address:hover {
  color: #0056b3;
}

.name-row, .street-row, .postal-phone-row {
  display: block;
}

@media (min-width: 768px) {
  .name-row, .street-row, .postal-phone-row {
    display: flex;
    gap: 10px;
  }

  .name-row input, .street-row input, .postal-phone-row input {
    flex: 1;
  }
}

input, select {
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
select {
  appearance: none;
  background: url('data:image/svg+xml;utf8,<svg fill="%23999" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>') no-repeat right 10px center;
  background-size: 24px;
}
.order-button {
  width: 100%;
  padding: 10px 20px;
  background-color: #d3d3d3;
  color: black;
  border: 1px solid black;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.order-button:hover {
  background-color: #a9a9a9;
}

.delivery-options {
  margin-bottom: 20px;
}

.delivery-options h2 {
  margin-bottom: 10px;
}

.delivery-option {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
}

.delivery-option input[type="radio"] {
  margin-right: 10px;
  border: 2px solid #ccc;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  appearance: none;
  outline: none;
  cursor: pointer;
  position: relative;
}

.delivery-option input[type="radio"]:checked {
  border-color: black;
}

.delivery-option input[type="radio"]:checked::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background-color: black;
  border-radius: 50%;
}

.delivery-option label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.delivery-option span {
  margin-left: auto;
  font-weight: bold;
}

@media (min-width: 768px) {
  .checkout-page {
    flex-direction: row;
  }

  .checkout-content {
    flex: 6;
  }

  .order-summary {
    flex: 4;
    border: 1px solid #eee;
    position: sticky;
    top: 20px;
  }
}

h2 {
  font-weight: bold;
  text-align: left;
}

.shipping-address {
  margin-bottom: 20px;
}

.shipping-address h2 {
  font-weight: bold;
  text-align: left;
}

.address-details {
  border: 1px solid #e5e5e5;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.address-info {
  text-align: left;
}

.address-info p {
  margin: 5px 0;
}

.edit-button {
  cursor: pointer;
  color: #007bff;
  text-decoration: underline;
}

.street-row {
  display: flex;
  gap: 10px;
}

.street-row input,
.street-row select {
  flex: 1;
  position: relative;
}

.street-row input::placeholder,
.street-row select::placeholder {
  position: absolute;
  top: -10px;
  left: 0;
  font-size: 12px;
  color: #999;
}
</style> 